import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { payrollAPI, employeesAPI } from '../../lib/api';

const Payroll = () => {
  const [payroll, setPayroll] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [payrollRes, employeesRes] = await Promise.all([
        payrollAPI.getAll(),
        employeesAPI.getAll()
      ]);
      setPayroll(payrollRes.data);
      setEmployees(employeesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getEmployeeName = (empId) => {
    const emp = employees.find(e => e.id === empId);
    return emp?.name || '-';
  };

  const columns = [
    { key: 'employee_id', label: 'Employee', render: (val) => getEmployeeName(val) },
    { key: 'period', label: 'Period' },
    { key: 'basic_salary', label: 'Basic', type: 'currency' },
    { key: 'allowances', label: 'Allowances', type: 'currency' },
    { key: 'deductions', label: 'Deductions', type: 'currency' },
    { key: 'net_salary', label: 'Net Salary', type: 'currency' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    {
      name: 'employee_id',
      label: 'Employee',
      type: 'select',
      required: true,
      options: employees.map(e => ({ value: e.id, label: e.name })),
    },
    { name: 'period', label: 'Pay Period', required: true, placeholder: 'e.g., Jan 2024' },
    { name: 'basic_salary', label: 'Basic Salary', type: 'number', defaultValue: 0 },
    { name: 'allowances', label: 'Allowances', type: 'number', defaultValue: 0 },
    { name: 'deductions', label: 'Deductions', type: 'number', defaultValue: 0 },
    { name: 'net_salary', label: 'Net Salary', type: 'number', defaultValue: 0 },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'pending',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'processed', label: 'Processed' },
        { value: 'paid', label: 'Paid' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await payrollAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await payrollAPI.update(id, data);
    fetchData();
  };

  const handleDelete = async (id) => {
    await payrollAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Payroll"
      description="Manage employee payroll"
      data={payroll}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Payroll;
